import React from 'react';
import IconBase from './IconBase';
const LinkedInIcon = props => React.createElement(IconBase, props, React.createElement("g", null, React.createElement("rect", {
  x: "3.685",
  y: "23.509",
  width: "12.32",
  height: "36.938"
}), React.createElement("path", {
  d: "M46.247,22.641c-6.545,0-9.469,3.59-11.106,6.104v0.119h-0.081c0.023-0.038,0.056-0.08,0.081-0.119v-5.236H22.818 c0.166,3.468,0,36.938,0,36.938h12.324V39.818c0-1.105,0.084-2.204,0.409-2.994c0.891-2.209,2.917-4.492,6.321-4.492 c4.459,0,6.241,3.388,6.241,8.352v19.762h12.32V39.267C60.435,27.92,54.356,22.641,46.247,22.641z"
}), React.createElement("path", {
  d: "M9.927,5.703c-4.216,0-6.974,2.756-6.974,6.381c0,3.546,2.678,6.385,6.81,6.385h0.082c4.298,0,6.971-2.839,6.971-6.385 C16.735,8.459,14.143,5.703,9.927,5.703z"
})));
LinkedInIcon.defaultProps = {
  title: 'LinkedInIcon'
};
export default LinkedInIcon;
//# sourceMappingURL=LinkedInIcon.js.map